import DOMPurify from 'dompurify';

const RELEASE_HOSTS = new Set(['maintella.com', 'www.maintella.com']);
const RELEASE_ASSET_PATH_PREFIX = '/content/releases/';

const ALLOWED_TAGS = [
  'p', 'br', 'strong', 'em', 'b', 'i', 'u', 'a', 'img',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'ul', 'ol', 'li', 'blockquote', 'pre', 'code',
  'figure', 'figcaption', 'video', 'source',
  'table', 'thead', 'tbody', 'tr', 'th', 'td',
];

const ALLOWED_ATTR = ['href', 'src', 'alt', 'title', 'controls', 'id', 'target', 'rel'];

let hooksInstalled = false;

function installHooks() {
  if (hooksInstalled || typeof window === 'undefined') return;

  DOMPurify.addHook('uponSanitizeAttribute', (node, data) => {
    if (data.attrName === 'src' && node.tagName === 'IMG' && !isAllowedAssetUrl(data.attrValue)) {
      data.keepAttr = false;
    }
  });

  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName !== 'A' || node.getAttribute('target') !== '_blank') return;

    const rel = new Set((node.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
    rel.add('noopener');
    rel.add('noreferrer');
    node.setAttribute('rel', [...rel].join(' '));
  });

  hooksInstalled = true;
}

export function isAllowedAssetUrl(url) {
  if (!url) return false;

  try {
    if (url.startsWith('/')) {
      return url.startsWith(RELEASE_ASSET_PATH_PREFIX);
    }

    const parsed = new URL(url);
    return (
      parsed.protocol === 'https:'
      && RELEASE_HOSTS.has(parsed.host)
      && parsed.pathname.startsWith(RELEASE_ASSET_PATH_PREFIX)
    );
  } catch {
    return false;
  }
}

export function isAllowedReleaseLink(url) {
  if (!url) return false;

  try {
    const parsed = new URL(url);
    return (
      parsed.protocol === 'https:'
      && RELEASE_HOSTS.has(parsed.host)
      && parsed.pathname.startsWith('/releases')
    );
  } catch {
    return false;
  }
}

export function sanitizeReleaseHtml(html) {
  if (!html) return '';

  installHooks();

  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
  });
}
